
const React = require('react');
const HeaderMixin = require('./mixins/header').HeaderMixin;
const StripeButton = require('./button.stripe.jsx').StripeButton;
const EditProfile = require('./profile.edit.jsx').ProfileEdit;
const HoldAccount = require('./account.hold.jsx').HoldAccount;
const AccountStatus = require('../enums/accountstatus');

const Marketing = React.createClass({
    mixins: [HeaderMixin],

    showProfile: function() {
        this.refs.profile.openModal();
    },

    holdMe: function() {
        this.refs.hold.openModal();
    },

    getRemoveAccountMailto() {
        let body = `${this.props.PublishedURL || (this.props.user.givenName + " " + this.props.user.surname)}\r\n${this.props.user.email}`;

        let link = `mailto:support@thefarmboard.com?subject=${encodeURIComponent("Close Account Request")}&body=${encodeURIComponent(body)}`;
        return link;
    },

    render: function() {
    	let middle = this.props.hideContent?
			<div className="middle"><div id="google_translate_element"></div></div>:
            <div className="middle">farmers...  <a href="/">sell more, save time, delight customers!</a><br/>
                buyers... <a href="/">buy more, save time!</a><br/>
                farmers markets... <a href="/">increase visits, increase sales!</a><br/>
                Already have an account?&nbsp;&nbsp;<a href="/login">Login</a><br/><div id="google_translate_element"></div></div>;

        let manage;
        if (this.props.hideContent) {
            const profileLink = <a href="#" onClick={this.showProfile} className="edit" title="Edit Profile">Profile</a>;
            const paymentLink = <div className="group"><StripeButton onSuccess={this.props.onPaymentSuccess} user={this.props.user}><a href="#" className="edit" title="Update Payment Info" type="submit">Payment</a></StripeButton></div>;
          //  const holdMeLink = (!this.props.hideFreeze && (AccountStatus && (this.props.AccountStatus == AccountStatus.active.value))?<a href="#" onClick={this.holdMe} className="edit" title="Freeze Account">Freeze Account</a>:null);
            const logoutLink = <a href="/logout" className="logout" title="Logout">Logout</a>;
            const removeAccountLink = <a href={this.getRemoveAccountMailto()} className="edit" title="Remove Account">Close</a>;

            manage = <div className="link-wrapper">
                        <span className="link-list-title">Account</span>
                        <ul className="link-list">
                            <li>{profileLink}</li>
                            <li>{paymentLink}</li>
                            <li>{removeAccountLink}</li>
                            <li>{logoutLink}</li>
                        </ul>
                        <EditProfile ref="profile" user={this.props.user}/>
                    </div>;
        }

        let aboutUs;
        if (this.props.hideContent) {
        aboutUs = <div className="link-wrapper">
                    <span className="link-list-title">theFarmboard</span>
                    <ul className="link-list">
                        <li><a href="/">Home</a></li>
                        <li><a href="mailto:info@thefarmboard.com">Contact</a></li>
                        <li><a href="/static/legal/termsofuse.html" target="_blank">Terms</a></li>
                    </ul>
                  </div>;
        }

        return (
            <footer className="layout-footer">
            	<div className="left">
            		<img src="/static/fb-logo-watermark.png" />
                    <p className="copyright">© 2020 theFarmBoard PBC</p>
            	</div>
                
				{middle}

            	<div className="right">
                    {manage}
                    {aboutUs}
				</div>

            </footer>
		)
    }
});

exports.Marketing = Marketing;

